import dailyKorean from './wordSets/daily-korean.json';
import nintendoKorean from './wordSets/nintendo-korean.json';
import programmingJS from './wordSets/programming-js.json';
import programmingCSS from './wordSets/programming-css.json';
import programmingHTML from './wordSets/programming-html.json';
import programmingPython from './wordSets/programming-python.json';

export const getWordSets = (t) => [
  {
    category: t('categories.daily'),
    categoryKey: 'daily',
    sets: [dailyKorean]
  },
  {
    category: t('categories.game'),
    categoryKey: 'game',
    sets: [nintendoKorean]
  },
  {
    category: t('categories.programming'),
    categoryKey: 'programming',
    sets: [programmingHTML, programmingCSS, programmingJS, programmingPython]
  }
];

export const getWordSetById = (id) => {
  const allSets = [
    dailyKorean,
    nintendoKorean,
    programmingHTML, 
    programmingCSS, 
    programmingJS, 
    programmingPython
  ];
  
  return allSets.find(set => set.id === id) || null;
};